// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"AuditionMessagingDropdownMenu_dropdownMenu__avKfx","dropdownPlaceholder":"AuditionMessagingDropdownMenu_dropdownPlaceholder__iC+Mm"};